<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        class="top-customers"
        title="Top 3 klanten"
        :icon="invoiceDetailsIcon"
        align-top>
      <div v-if="loading">
        <dean-spinner
            size="80"
            :full-circle="true"
        ></dean-spinner>
      </div>
      <table class="topCustomers">
        <tr v-for="(item, index) in data">
          <td>
            {{ index + 1 }}.
          </td>
          <td>
            {{ item.name }}
          </td>
          <td>
            &euro;{{ item.amount }}
          </td>
        </tr>
      </table>
    </dean-dialog>
  </div>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import axios from 'axios';
  import {Component, Prop, Watch} from 'vue-property-decorator';
  import {deanDialogBus} from '@/main';

  // DEAN COMPONENTS
  import {
    deanDialog,
    invoiceDetailsIcon,
    deanIcon,
    deanSpinner,
    deanInputField,
    deanButton,
  } from '@deanone/dean-components';

  @Component({
    components: {
      invoiceDetailsIcon,
      deanIcon,
      deanSpinner,
      deanInputField,
      deanDialog,
      deanButton,
    },
  })


  export default class TopCustomersWidget extends Vue {
    public loading: boolean = false;
    public invoiceDetailsIcon: object = invoiceDetailsIcon;
    public data: Array<{
      name: string
      amount: any,
    }> = [];

    /**
     * Call appshell view with results
     *
     * @param      {any}  event   The event
     */
    public created(event: any) {
      const url = '/-/trade/api/widgets.topCustomers';

      this.loading = true;
      axios
        .post(url)
        .then(
          (response) => {
            this.data = response.data.data;
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          }).finally(() => {
        this.loading = false;
      });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .topCustomers {
    width: 100%;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: bold;
    text-align: left;
    border-collapse: separate;
    border-spacing: 10px 15px;

    td:nth-child(3) {
      text-align: right;
    }
  }

  .dialog :deep {
    padding: 0;
  }

  :deep(.dialog) .dean-dialog-container,
  :deep(.dialog) .dean-dialog-content {
    width: 100%;
    height: 100%;
  }
</style>
